const prod = {
  url: {
    API_URL: "https://data-core.teampbs.com/enterprise/api",
    SHAREPOINT_SITE_URL: "https://sharepoint.teampbs.com",
  },
  aadClientID: "72b970f1-4914-47f8-870c-78a957593e5d",
  tenantID: "a43be288-8913-475d-97de-5b99b3dcc172",
  redirectUri: "https://profile.teampbs.com",
  googleMapsApiKey: "AIzaSyDHcOI817pTrHiBk_rRCw3N72feKieEsBg",
};

//PRD: "https://data-core.teampbs.com/enterprise/api",
//DEV: "https://localhost:7494/api",

const dev = {
  url: {
    API_URL:"https://data-core.teampbs.com/enterprise/api",// 
    SHAREPOINT_SITE_URL: "https://sharepoint.teampbs.com",
  },
  aadClientID: "72b970f1-4914-47f8-870c-78a957593e5d",
  tenantID: "a43be288-8913-475d-97de-5b99b3dcc172",
  redirectUri: "http://localhost:3000",
  googleMapsApiKey: "AIzaSyDHcOI817pTrHiBk_rRCw3N72feKieEsBg",
};

export const config = process.env.NODE_ENV === "development" ? dev : prod;
